import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import UserAchievements from './pages/UserAchievements';
import MyProfile from './components/settings/MyProfile';
import SettingsLayout from './components/settings/SettingsLayout';
import AccountSettings from './components/settings/AccountSettings';
import CompleteProfile from './pages/CompleteProfile';
import PublicProfile from './pages/PublicProfile';
import UserArchived from './pages/UserArchived';
import ActivityPage from './pages/ActivityPage';
import Leaderboard from './pages/LeaderBoardPage/Leaderboard'; 
import { useState, useEffect, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import TopNav from './components/TopNav';
import Test from './components/test';
import Login from './pages/Login';
import SearchPage from './pages/SearchPage';
import Home from './pages/Home';
import api from './api/client';
import {getCurrentUser} from "./api/userApi"
import DonationFlow from './pages/DonationFlow';
import ServiceRequestHistory from './pages/ServiceRequestHistory';
import AdminDashboard from './pages/AdminDashboard';
import AboutHelp from './pages/AboutHelp'; // Import the help page
import Footer from './components/Footer'; // Import your footer
import VerifyMagicLink from './pages/VerifyMagicLink';
import AuthContext from "./context/AuthContext";
import OnboardingGoalPicker from './pages/OnboardingGoalPicker';
import AppearanceSettings  from './pages/AppearanceSettings';
import NotificationSettings from './components/settings/NotificationSettings';
import InstallAppSettings from './components/settings/InstallAppSettings';
import RecruitersPage from './pages/RecruitersPage';

function AppContent({ sessionReady, setSessionReady }) {
const { currentUser, setCurrentUser, authLoading } = useContext(AuthContext);


   useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenFromUrl = params.get('token');
    if (tokenFromUrl) {
      localStorage.setItem('X-Auth-Token', tokenFromUrl);
      api.defaults.headers.common['X-Auth-Token'] = tokenFromUrl;
      window.history.replaceState({}, document.title, window.location.pathname);

    }
  }, []);

  if (authLoading) return <p>Initializing...</p>;

  return (
    <>
      <TopNav currentUser={currentUser} setCurrentUser={setCurrentUser} />
      <Routes>

<Route
  path="/service-request"
  element={
    <ProtectedRoute currentUser={currentUser}>
      <DonationFlow />
    </ProtectedRoute>
  }
/>
<Route
  path="/service-request/success"
  element={
    <ProtectedRoute currentUser={currentUser}>
      <ServiceRequestHistory />
    </ProtectedRoute>
  }
/>
<Route
  path="/service-request/history"
  element={
    <ProtectedRoute currentUser={currentUser}>
      <ServiceRequestHistory />
    </ProtectedRoute>
  }
/>

<Route path="/auth/verify" element={<VerifyMagicLink setCurrentUser={setCurrentUser} />} />




        <Route path="/login" element={<Login />} />

        {/* Only accessible if logged in but profile incomplete */}
        <Route
  path="/complete-profile"
  element={
    currentUser ? (
      !currentUser.profileCompleted ? (
        <CompleteProfile currentUser={currentUser} setCurrentUser={setCurrentUser} />
      ) : (
        <Navigate to="/onboarding" replace />
      )
    ) : (
      <Navigate to="/login" replace />
    )
  }
/>
      <Route
  path="/onboarding"
  element={
    currentUser ? (
      <OnboardingGoalPicker currentUser={currentUser} />
    ) : (
      <Navigate to="/login" replace />
    )
  }
/>

        {/* Fully Protected Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute currentUser={currentUser}>
              <Home currentUser={currentUser} />
            </ProtectedRoute>
          }
        />

        <Route path="/profile/:userId" element={<PublicProfile />} />

        <Route
          path="/leaderboard"
          element={
            <ProtectedRoute currentUser={currentUser}>
              <Leaderboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ActivityPage"
          element={
            <ProtectedRoute currentUser={currentUser}>
              <ActivityPage currentUser={currentUser} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/:userId/achievements"
          element={
            <ProtectedRoute currentUser={currentUser}>
              <UserAchievements/>
            </ProtectedRoute>
          }
        />
        <Route
  path="/achievements"
  element={
    <ProtectedRoute currentUser={currentUser}>
      <UserAchievements />
    </ProtectedRoute>
  }
/>

        <Route
          path="/archived"
          element={
            <ProtectedRoute currentUser={currentUser}>
              <UserArchived currentUser={currentUser} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <ProtectedRoute currentUser={currentUser}>
              <SettingsLayout user={currentUser} />
            </ProtectedRoute>
          }
        >
          {/* This makes /settings redirect to /settings/profile automatically */}
          <Route index element={<Navigate to="profile" replace />} />
          <Route 
  path="profile" 
  element={
    <MyProfile 
      user={currentUser} 
      onUpdate={(updatedUser) => setCurrentUser(prev => ({ ...prev, ...updatedUser }))} 
    />
  } 
/>
           <Route path="account" element={<AccountSettings user={currentUser} />} />
<Route path="notifications" element={<NotificationSettings />} />
 <Route path="appearance" element={<AppearanceSettings />} />
 <Route path="install" element={<InstallAppSettings />} />
        </Route>
       
       <Route
  path="/search"
  element={
    <ProtectedRoute currentUser={currentUser}>
      <SearchPage />
    </ProtectedRoute>
  }
/>

        <Route
          path="/test"
          element={
            <ProtectedRoute currentUser={currentUser}>
              <Test />
            </ProtectedRoute>
          }
        />

        <Route
  path="/admin"
  element={
    <ProtectedRoute currentUser={currentUser}>
      <AdminDashboard />
    </ProtectedRoute>
  }
/>

{/* 🟢 Add the new Help Route (Publicly accessible) */}
        <Route path="/help" element={<AboutHelp />} />

        {/* You can also add it as a protected route if you prefer: */}
        {/* <Route path="/help" element={<ProtectedRoute currentUser={currentUser}><AboutHelp /></ProtectedRoute>} /> */}

          {/** RECRUITERS PAGE */}
      <Route path="/recruiters" element={<RecruitersPage/>} />
      </Routes>




<Footer />
    
    </>

  );
}

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [sessionReady, setSessionReady] = useState(false);

  return (
    <BrowserRouter>
      <AppContent
        currentUser={currentUser}
        setCurrentUser={setCurrentUser}
        sessionReady={sessionReady}
        setSessionReady={setSessionReady}
      />
    </BrowserRouter>
  );
}

export default App;
